import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/signals/groups';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation() {
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/signal/groups`,
      { headers: getLocalUser() },
    );
    const body = response?.data?.data?.data ?? {};
    yield put(fetchSuccess(body));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
